import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST, CLIPPER_HOST, CLIPPER_HOST_NEW } from '../../config/app-const';

let cancelTokenSource;


const pollURI = async (url, retryInterval = 10000, maxRetries = 18) => {
  for (let i = 0; i < maxRetries; i++) {
    try {
      const statusResponse = await Axios.get(url);
      if (statusResponse.status === 200 || statusResponse.status ===  202 && statusResponse.data) {
        if (statusResponse.data.status === "in progress" || statusResponse.data === 'inprogress' ){
          console.log("status still in progress, continuing to poll...");
        }else{
          return statusResponse.data;
        }
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 502) {
          console.log('Received 502 Bad Gateway, retrying...');
        } else if (error.response.status === 422 || error.response.status > 500) {
          console.log(`Resource failed with status ${error.response.status}, retrying...`);
        } else {
          console.log('Resource is locked, retrying...');
        }
      } else {
        console.log('Error without response:', error.message);
      }
    }
    await new Promise(resolve => setTimeout(resolve, retryInterval));
  }
  throw new Error('Max retries reached, asset processing not completed');
};

const state =  {
  keyframes: {
    data: [],
    isBusy: false,
    error: null,
  },
  articleAssetsData: {
    isBusy: false,
    data: null,
    error: null,
  },
  save: {
    isBusy: false,
    error: null
  },
  s3Upload: {
    isbusy:false,
    error: null
  }
};

const mutations = {
    LOAD_KEYFRAMES_FETCH_BUSY: (state, payload) => {
      state.keyframes.isBusy = payload;
    },
    LOAD_KEYFRAMES_FETCH_SUCCESS: (state, payload) => {
      state.keyframes.data = payload;
    },
    LOAD_KEYFRAMES_FETCH_FAIL: (state, payload) => {
      state.keyframes.error = payload;
    },
    LOAD_ARTICLE_ASSETS_DATA_BUSY: (state, payload) => {
      state.articleAssetsData.isBusy = payload;
    },
    LOAD_ARTICLE_ASSETS_DATA_SUCCESS: (state, payload) => {
      state.articleAssetsData.data = payload;
      state.articleAssetsData.error = null;
    },
    LOAD_ARTICLE_ASSETS_DATA_FAIL: (state, payload) => {
      state.articleAssetsData.data = null;
      state.articleAssetsData.error = payload;
    },
    LOAD_SAVE_FETCH_BUSY: (state, payload) => {
      state.save.isBusy = payload;
    },
    LOAD_SAVE_FETCH_FAIL: (state, payload) => {
      state.save.error = payload;
    },
    LOAD_S3_UPLOAD_BUSY: (state, payload) => {
      state.s3Upload.isBusy = payload;
    },
    LOAD_S3_UPLOAD_FAIL: (state, payload) => {
      state.s3Upload.error = payload;
    },
};

const actions = {
  clipSection: async (_, {src, isLocal, startTime, endTime, mimeType} ) => {
    try{
      if (mimeType !== 'audio/mp3' && mimeType !== 'video/mp4') {
        throw new Error(`Error unexpected Mime type ${mimeType}`);
      }
      const host = CLIPPER_HOST_NEW;
      const mediaPathToClip = `${host}/clip?${isLocal ? 'filename' : 'url'}=${encodeURIComponent(src)}&startTime=${startTime}&endTime=${endTime}`;
      const clippingAssetRes =  await pollURI(mediaPathToClip);
      if (clippingAssetRes.clipPath) {
        return {src: host + clippingAssetRes.clipPath, filepath: clippingAssetRes.clipPath};
      } else {
        throw new Error("Clip path is unavailable.");
      }
    }catch(err){
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
      console.log(err)
    }
  },
  uploadAssetToS3: async({commit}, data) => {
    commit('LOAD_S3_UPLOAD_BUSY', true);
    try {
      const response = await Axios.post(`${API_HOST}/clipper/upload-to-s3`, { url: data.src, ...data });
      return response.data;
    } catch (error) {
      console.error(error);
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
    }finally {
      commit('LOAD_S3_UPLOAD_BUSY', false);
    }
  },
  updateArticle: async ({ commit }, data) => {
    commit('LOAD_SAVE_FETCH_BUSY', true);
    try {
      const response = await Axios.post(`${API_HOST}/clipper/update-article`, data );
      if (response.data.syncInsightError){
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('mediaClipper.form.success_with_sync_error'),
        });
      }else{
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('mediaClipper.form.success_message'),
        });
      }
      return response.data;
    } catch (error) {
      console.error(error);
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
    } finally {
      commit('LOAD_SAVE_FETCH_BUSY', false);
    }
  },
  deleteSection: async (_, { path, isLocal, startTime, endTime }) => {
    const encodedPath = encodeURIComponent(path);
    const host = CLIPPER_HOST_NEW;
    const deletePath = `${host}/deletesection?${isLocal ? 'filename=' : 'url='}${encodedPath}&startTime=${startTime}&endTime=${endTime}`
    try {
      let deleteResponse = await pollURI(deletePath, 3000, 3);
      return {src: host + deleteResponse.finalFile, filepath : deleteResponse.finalFile, totalDuration : Math.round(deleteResponse.totalDuration)}
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
      console.error('Error:', error.message);
      throw new Error(`Error fetching or processing asset data: ${error.message}`);
    }
  },
  fetchArticleOriginalExtendedAsset: async ({ commit }, { articleId }) => {
    commit('LOAD_ARTICLE_ASSETS_DATA_BUSY', true);
    try {
      const response = await Axios.post(`${API_HOST}/clipper/article-extended-asset`, {articleId});
      commit('LOAD_ARTICLE_ASSETS_DATA_SUCCESS', {
        channelRecordings: response.data.channelRecordings,
        isEdited: response.data.isEdited
      });
      if (response.data.notFound){
        Vue.notify({
          group: 'store_notifications',
          type: 'warn',
          text: i18n.t('mediaClipper.form.deleted_asset')
        });
      }
      return response.data;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error'),
      });
      console.error(error);
      commit('LOAD_ARTICLE_ASSETS_DATA_FAIL', error);
      return Promise.reject(error);
    } finally {
      commit('LOAD_ARTICLE_ASSETS_DATA_BUSY', false);
    }
  },
  fetchArticleAsset: async ({ _ }, articleId ) => {
    try {
      const response = await Axios.post(`${API_HOST}/clipper/article-asset`, {articleId});
      if (response.data.notFound){
        Vue.notify({
          group: 'store_notifications',
          type: 'warn',
          text: i18n.t('mediaClipper.form.deleted_asset')
        });
      }
      return response.data;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error'),
      });
      console.error(error);
      return Promise.reject(error);
    }
  },
  ffprobeMediaDuration: async (_, { path, isLocal }) => {
    const encodedPath = encodeURIComponent(path);
    const host =  CLIPPER_HOST_NEW;
    const ffprobeUrl = `${host}/ffprobe?${isLocal ? 'filename=' : 'url='}${encodedPath}`
    try {
      const response = await pollURI(ffprobeUrl, 3000, 3);
      const result = {
        url: isLocal ? `${host}${path}` : path,
        filepath: isLocal ? path : null,
        duration: response.format.duration,
        mimeType: response.streams[0].codec_type
      };
      return result;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
      return { path, error };
    }
  },
  fetchMp4Keyframes: async ({ commit }, { url, isLocal }) => {
    const encodedUrl = encodeURIComponent(url);
    const host =  CLIPPER_HOST_NEW;
    const keyframesUrl = `${host}/keyframes?${isLocal ? 'filename=' : 'url='}${encodedUrl}`;
    try {
      commit('LOAD_KEYFRAMES_FETCH_BUSY', true);
      if (cancelTokenSource) {
        cancelTokenSource.cancel('Request canceled due to reload or new request.');
      }
      cancelTokenSource = Axios.CancelToken.source();

      const response = await pollURI(keyframesUrl, 3000, 3);
      if (response.keyframes) {
        commit('LOAD_KEYFRAMES_FETCH_SUCCESS', response.keyframes);
      }
    } catch (error) {
      console.error('Failed to fetch keyframes:', error);
      commit('LOAD_KEYFRAMES_FETCH_FAIL', error);
      return Promise.reject(error);
    } finally {
      commit('LOAD_KEYFRAMES_FETCH_BUSY', false);
    }
    
  },  
  mergeArticleAssets: async (_, {files, mediaFormat}) => {  
    try {
      const host = CLIPPER_HOST_NEW;
      const mergeResponse = await Axios.post(`${host}/merge`, { segments: files, format: mediaFormat });
        return {
          mergedFile: {
            filepath: mergeResponse.data.mergedFile,
            src: host + mergeResponse.data.mergedFile
          },
          totalDuration: Math.floor(mergeResponse.data.totalDuration),
        }
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
      console.error('Error during merging assets:', error.message);
      throw new Error(`Error fetching or processing asset data: ${error.message}`);
    }
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
